module.exports = __webpack_public_path__ + "static/media/0_4000_100_B.70462bd4.pdb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/0_4000_100_B.pdb
// module id = 1780
// module chunks = 1